module.exports = __webpack_public_path__ + "static/payoff-animation-3ec16b1e843bb65434fcf295c4979379.mp4";